export class InsignProcedureModel {
  id: number;
  title: string;
  clientId: string;
  firstName: string;
  lastName: string;
  email: string;
  status: 'INITIALIZED' | 'OPEN' | 'SIGNED' | 'PARTIALLY_SIGNED';
  createdAt: Date;
  updatedAt: Date;
  documentToSignList: InsignDocumentModel[];
  inSignSessionId: string;
  userSignatures: InsignUserSignatureModel[];
  requiredSignatures: number;
  signedSignatures: number;
  anonymous: boolean;
}

export class InsignDocumentModel {
  id: number;
  createdAt: Date;
  documentName: string;
  downloadUrl: string;
  downloaded: boolean;
  signedAt: Date;
}

export class InsignUserSignatureModel {
  id: number;
  email: string;
  externAccessLink: string;
  signed: boolean;
  signedAt: Date;
}

export class InsignProcedureLogModel {
  createdAt: Date;
  procedureLogType:
    | 'SIGNATURE_PROCESS_STARTED'
    | 'SENT_CHAT_MESSAGE_AND_EMAIL'
    | 'SENT_EMAIL'
    | 'SENT_CHAT_MESSAGE'
    | 'DOCUMENT_MANDATE_CREATED'
    | 'ALL_SIGNATURES_COMPLETED';
}

export class InsuranceTransferRequestModel {
  clientFirstName: string;
  clientLastName: string;
  clientEmail: string;
  clientId: string;
  advisorId: string;
  clientAddress: string;
  birthDate: string;
  advisorsName: string;
  company: string;
  policyNumber: string;
  insuranceType: string;
  insuranceCompany: string;
  premiumAmount: string;
  premiumValue: number;
  gpNumber: string;
  place: string;
  referenceId: string;
  isEditable: boolean;
}

export class InsignSignatureFieldModel {
  documentName: string;
  signerEmail: string | null;
  mandatory: boolean;
  signed: boolean;
  signedAt: Date | null;
}
